<div class="skeleton" *ngIf="!exibiConteudo">
  <ngx-skeleton-loader
    count="1"
    [theme]="{
      'border-radius': '5px',
      width: '80%',
      height: '70px',
      'margin-bottom': '17px'
    }"
  ></ngx-skeleton-loader>

  <ngx-skeleton-loader
    count="1"
    [theme]="{
      'border-radius': '5px',
      width: '70%',
      height: '36px',
      margin: '0 0 45px 0'
    }"
  ></ngx-skeleton-loader>

  <ngx-skeleton-loader
    count="4"
    [theme]="{
      'border-radius': '5px',
      width: '50%',
      height: '30px',
      margin: '0 0 45px 0',
      display: 'grid'
    }"
  ></ngx-skeleton-loader>
</div>

<div class="container__geral" *ngIf="exibiConteudo">
  <div class="container">
    <div class="info__remocao">
      <p class="info__titulo">
        Sentimos muito que queira dar um tempo em nosso relacionamento.
      </p>
      <p class="info__descricao">
        Com esta decisão, você perdeu automaticamente os benefícios do programa,
        como por exemplo:
      </p>
      <div class="info__topicos">
        <span class="texto__topicos"
          ><img
            class="icone"
            src="../../../../assets/images/icons/healthicons_coins.png"
          />Preços especial nos produtos (Preço Cacau Lovers)</span
        >
        <span class="texto__topicos"
          ><img
            class="icone"
            src="../../../../assets/images/icons/cacaus-pequenos.png"
          />Acúmulo de Cacaus</span
        >
        <span class="texto__topicos"
          ><img
            class="icone"
            src="../../../../assets/images/icons/etiqueta.png"
          />Acesso a todas as promoções</span
        >
        <span class="texto__topicos"
          ><img
            class="icone"
            src="../../../../assets/images/icons/Cake.png"
          />Mimo no seu aniversário</span
        >
      </div>
      <p class="info__descricao">
        Caso mude de ideia, veja a seguir como reatar o nosso relacionamento:
      </p>
      <ol class="vantagens__relacionamento">
        <li>Faça o login no site Cacau Lovers</li>
        <li>Clique no seu nome no menu superior</li>
        <li>Clique em "Meus dados"</li>
        <li>
          Dê o aceite na comunicação em "Li e aceito os termos e condições do
          Programa Cacau Lovers" no final da página
        </li>
      </ol>
    </div>
    <div class="icone__remocao">
      <img
        class="icone"
        src="../../../../assets/images/icons/remocao-aceite-comunicacao.png"
        alt="sem notificação"
      />
    </div>
  </div>
  <img
    class="background"
    src="../../../../assets/images/backgrounds/background_gradiente_cima.png"
  />
</div>
